import {IRouteDefinitionParams, ISecurityLog, ITableColumn} from "../../../index";
import {AbstractSearch, tpl} from "../AbstractSearch";
import {getHash} from "../../../constants/RouteDefinitions";
import {lm} from "../../../appContext";
import {escapeHTML} from "../../../util/misc";

export const template = tpl

export class viewModel extends AbstractSearch<ISecurityLog> {
    protected readonly TABLE: ITableColumn<ISecurityLog>[] = [
        {key: 'Id'},
        {key: 'EntryType'},
        {
            key: 'ObjectId', label: 'object', getContent: (o: ISecurityLog) => {
                return `<span title="${lm.t('((object)) [((id|ac))]')}">${this.markText('objectid', o.objectid)}</span>
                <br>
                <span title="${lm.t('((object)) [((name|ac))]')}">
                    <a href="${getHash('userdetails', {id: o.objectid}, true, o.companyid)}">${this.markText('objectname', escapeHTML(o.objectname))}</a>
                </span>`
            },
        },
        {key: 'Registered', label: 'date'},
        {key: 'registeredby'},
        {key: 'Ip'},
        {key: 'comment', html: false},
        {key: 'CompanyId', label: 'organization', validator: () => this.allOrganizations()},
    ]

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.init()
    }

}
